// src/index.jsx - Entry point (if needed)
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startAnalytics } from './services/analytics';
import './index.css';

// Before React mounts: loads GA4 only for someone who has already said yes.
startAnalytics();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);